import { render } from "./Image.vue?vue&type=template&id=2b4cb008&scoped=true"
const script = {}

import "./Image.vue?vue&type=style&index=0&id=2b4cb008&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4cb008"]])

export default __exports__